meedy.directive('meedyTime', ['$parse',
    function($parse) {
        var definition = {
            require: 'ngModel',
            restrict: 'E',
            scope: {
                minTime: '=',
                maxTime: '=',
                ngModel: '=',
                label: '@',
                ngChange: '&',
                required: '@',
                name: '@',
                roundToFive: '@?'
            },
            templateUrl: 'meedy/application/directive/meedyTime/template/meedy-time.html',
            link: function($scope, element, attr, ngModelCtrl) {

                var currentTime;

                function getDateFromTime (timeStr) {
                    var d = new Date(0);
                    if(timeStr && timeStr.length === 5) {
                        d.setHours(timeStr.substr(0, 2), timeStr.substr(3, 2), 0 ,0);
                    } else {
                        return;
                        d.setHours(0, 0, 0 ,0);
                    }
                    return d;

                }

                $scope.$watch('ngModel', function (newVal, oldVal) {
                    if(newVal) {
                        var hours = newVal.getHours();
                        hours = hours < 10 ? '0' + hours : hours;
                        var minutes = newVal.getMinutes();
                        minutes = minutes < 10 ? '0' + minutes : minutes;
                        var onlyTime = hours + ':' + minutes;

                        if(!$scope.onlyTime || onlyTime.substr($scope.onlyTime) == -1) {
                            $scope.onlyTime = onlyTime;
                        }

                    } else if(!newVal && oldVal) {
                        $scope.onlyTime = null;
                    }
                    $scope.ngChange();
                });

                ngModelCtrl.$validators.invalidDateTime = function () {
                    var date = angular.copy($scope.ngModel);
                    if(date) {
                        date.setSeconds(0);
                        date.setMilliseconds(0);
                    } else if(!date && $scope.ngRequired) {
                        element.find('.md-datepicker-input-container').addClass('md-datepicker-invalid');
                        element.find('md-input-container').addClass('md-input-invalid');
                        return false;
                    }
                    var minTime = angular.copy($scope.minTime);
                    if(minTime) {
                        minTime.setSeconds(0);
                        minTime.setMilliseconds(0);
                    }
                    var maxTime = angular.copy($scope.maxTime);
                    if(maxTime) {
                        maxTime.setSeconds(0);
                        maxTime.setMilliseconds(0);
                    }
                    if(date && (minTime && date.getTime() < minTime.getTime()) || (maxTime && date.getTime() > maxTime.getTime())) {
                        element.find('.md-datepicker-input-container').addClass('md-datepicker-invalid');
                        element.find('md-input-container').addClass('md-input-invalid');
                        return false;
                    }

                    element.find('.md-datepicker-input-container').removeClass('md-datepicker-invalid');
                    element.find('md-input-container').removeClass('md-input-invalid');
                    return true;
                };

                $scope.validate = function () {
                    ngModelCtrl.$validate();
                };

                $scope.$watch(
                    function () {
                        if($scope.ngModel) {
                            return $scope.ngModel.getTime();
                        }
                    },
                    function (newValue, oldValue) {
                        if(newValue && newValue != oldValue) {
                            ngModelCtrl.$validate();
                        }
                    }
                );

                if($scope.minTime != undefined) {
                    $scope.$watch('minTime', function (modelValue, old) {
                        if (modelValue && modelValue != old) {
                            $scope.validate();
                        }
                    }, false);
                }

                if($scope.maxTime != undefined) {
                    $scope.$watch('maxTime', function (modelValue, old) {
                        if (modelValue && modelValue != old) {
                            $scope.validate();
                        }
                    }, false);
                }

                $scope.$watch('onlyTime', function(modelValue, old){
                    var val = modelValue, o = old;

                    if(!val || val == o) return;

                    if(val.length == 0) {
                        $scope.ngModel = null;
                        return;
                    }

                    if(val && val.match(/^[0-9]{2}:[0-9]{2}$/)) {

                        if($scope.roundToFive && !val.match(/^[0-9]{2}:[0-9]{1}[0,5]{1}$/)) {
                            var lastNum = val.substr(4, 5);
                            lastNum = parseInt(val.substr(4,5) < 5 ? '0' : '5');

                            val = val.substr(0, 4) + lastNum;
                        }

                    } else {
                        if(val.length === 4 && val[val.length-1] == ':') {
                            val = val.substr(0, 3);
                        }

                        if(val.length === 5) {
                            val = '00:00';
                        }
                    }

                    if(val.length === 2 && (!o || o.length < 2)) {
                        if(val[1] === ':') {
                            val = '0' + val;
                        } else
                            val = val + ':';
                    }

                    if(val.length > 5) {
                        val = val.substr(0, 5);
                    }

                    if(val.length === 1 && (!o || o.length < 1)) {
                        if(val > 2) {
                            val = '0' + val;
                        }
                    }

                    if(val.length === 5) {
                        var split = val.split(':');
                        var hours = split[0];
                        var minutes = split[1];
                        if(hours > 24) {
                            hours = '00';
                        }
                        if(minutes > 59) {
                            minutes = '00';
                        }
                        val = hours + ':' + minutes;
                    }

                    $scope.onlyTime = val;

                    currentTime = getDateFromTime(val);
                    if(currentTime) {
                        $scope.ngModel = currentTime;
                    }

                });


            }
        };

        return definition;
    }
]);